import Vue from 'vue';

Vue.use(require('vue-moment'));

Vue.filter('currency', function(value: any) {
  const num = parseFloat(value);
  if (!isNaN(num)) {
    return num.toLocaleString(undefined, {
      style: 'currency',
      currency: 'USD'
    });
  }

  return value;
});

Vue.filter('currencyTruncate', function(value: any) {
  const num = parseFloat(value);

  if (!isNaN(num)) {
    var res = num.toLocaleString(undefined, {
      style: 'currency',
      currency: 'USD'
    });

    res = res.replace(/\.../, '');

    return res;
  }

  return value;
});

Vue.filter('chargeTotalCurrency', function(value: any,replaceWithSpaces: boolean = false) {
  const num = parseFloat(value);
  if(num === 0){
    return "-";
  }
  else if (!isNaN(num)) {
    var res = num.toLocaleString(undefined, {
      style: 'currency',
      currency: 'USD'
    });

    if(replaceWithSpaces) {
      res = res.replace(/\.00/, '   ');
    }
    else {
      res = res.replace(/\.00/, '');
    }

    return res;
  }

  return value;
});

Vue.filter('initials', function(value: any) {
  if (value == null || typeof value !== 'string') {
    return value;
  }

  const valueString = value as string;
  return valueString.split(' ').map(s => s[0]).join('').toUpperCase();
});
